'use strict';

import { view } from '@/functions';

const prefix = '/notification-campaigns';
const scopes = ['read_notification_campaigns', 'write_notification_campaigns'];

export default [
    {
        path: prefix,
        name: 'notification-campaigns',
        meta: {
            title: 'Notification Campaigns',
            scopes
        },
        component: () => view('notification-campaigns/index')
    }
];
